import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface ConfigKeyListPayload {
  includeDeleted?: boolean;
  page?: number;
  limit?: number;
  scope?: string;
  productId?: number;
}

export interface ConfigKeyFormPayload {
  key_code: string;
  display_label: string;
  data_type: 'text' | 'number' | 'boolean' | 'date' | 'dropdown';
  default_value?: string;
  is_mandatory?: boolean;
  scope: 'global' | 'product' | 'tenant';
  product_id?: number;
  validation_rule?: string;
  group_category?: string;
  display_order?: number;
  notes: string;
}

const list = (payload: ConfigKeyListPayload) => {
  const { includeDeleted, page, limit, scope, productId } = payload;
  const params: Record<string, string> = {};
  if (includeDeleted) params.includeDeleted = 'true';
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  if (scope) params.scope = scope;
  if (productId) params.productId = String(productId);
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.masterConfigKeys}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.masterConfigKeys}/${id}`);

const create = (payload: ConfigKeyFormPayload) => http.post(API_ENDPOINTS.masterConfigKeys, payload);

const update = (id: number | string, payload: Partial<ConfigKeyFormPayload>) =>
  http.patch(`${API_ENDPOINTS.masterConfigKeys}/${id}`, payload);

const remove = (id: number | string) => http.delete(`${API_ENDPOINTS.masterConfigKeys}/${id}`);

const ConfigKeyService = { list, get, create, update, remove };

export default ConfigKeyService;
